import React, {
  Component,
  MouseEvent,
  ReactNode,
  useEffect,
  useState,
} from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import { Form } from "react-bootstrap";
import axios from "axios";
import { useStore } from "../store";
import Card from "react-bootstrap/Card";
import { Colors } from "../utils/style";
import ReactMarkdown from "react-markdown";

type Prop = {
  title?: string;
  description?: string;
  children?: ReactNode;
  width?: string;
  titleHeight?: string;
  backgroundColor?: string;
};
function CardComponent(props: Prop) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        color: Colors.DARK_GRAY,
        height: "100%",
      }}
    >
      <Card
        style={{
          width: "100%",
          backgroundColor: props.backgroundColor || "#e5e4e2",
        }}
      >
        <Card.Body
          className="text-center"
          style={{
            color: Colors.DARK_GRAY,
          }}
        >
          {props.title ? (
            <Card.Title
              style={{
                textAlign: "center",
                height: props.titleHeight ? props.titleHeight : "",
                fontSize: "15px",
              }}
            >
              {props.title}
            </Card.Title>
          ) : null}
          <Card.Text>
            <ReactMarkdown>{props.description}</ReactMarkdown>
          </Card.Text>
          {props.children ? <> {props.children}</> : null}
        </Card.Body>
      </Card>
    </div>
  );
}

export default CardComponent;
